import { SingleValue } from 'react-select';
import styled from 'styled-components';

import { Button, Select } from '../../../../../shared/Components';
import { Option } from '../../../../../shared/Components/Select/Select';

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const ArrowRight = styled.span`
  display: block;
  font-size: 20px;
  padding: 5px;
`;

const ArrowLeft = styled.span`
  display: block;
  transform: rotate(180deg);
  font-size: 20px;
  padding: 5px;
`;

const NumberArrow = styled.span`
  display: block;
  font-size: 20px;
  padding: 5px;
`;

interface PaginationControleProps {
  setPagination(item: any): void;
  pagination: any;
}

export default function PaginationControle({ setPagination, pagination }: PaginationControleProps) {
  return (
    <Row>
      <div style={{ flex: 1 }}>
        <Select
          defaultValue={{ value: '10', label: '10 items' }}
          value={pagination.limit as SingleValue<Option>}
          options={[
            { value: '10', label: '10 items' },
            { value: '20', label: '20 items' },
            { value: '50', label: '50 items' },
            { value: '100', label: '100 items' },
          ]}
          onChange={(item) => setPagination({ ...pagination, limit: item, offset: 0 })}
        />
      </div>
      <div style={{ flex: 1, textAlign: 'end' }}>
        <Button
          margin={'0 5'}
          disabled={pagination?.offset == 0}
          onClick={() => {
            setPagination({
              ...pagination,
              offset: 0,
            });
          }}
        >
          <NumberArrow>First</NumberArrow>
        </Button>

        <Button
          margin={'0 5'}
          disabled={pagination?.offset == 0}
          onClick={() => {
            setPagination({
              ...pagination,
              offset: Math.max(0, pagination?.offset - +pagination?.limit?.value),
            });
          }}
        >
          <ArrowLeft>&#8227;</ArrowLeft>
        </Button>

        <Button disabled={true} margin={'0 5'}>
          <NumberArrow>
            {Math.round(pagination?.offset / +pagination?.limit?.value) + 1}
          </NumberArrow>
        </Button>

        <Button
          disabled={
            pagination?.amount &&
            pagination?.amount ==
              Math.min(pagination?.offset + +pagination?.limit?.value, pagination?.amount)
          }
          onClick={() => {
            setPagination({
              ...pagination,
              offset: pagination?.offset + +pagination?.limit?.value,
            });
          }}
          margin={'0 5'}
        >
          <ArrowRight>&#8227;</ArrowRight>
        </Button>

        <Button
          margin={'0 5'}
          disabled={
            Math.min(pagination?.offset + +pagination?.limit?.value, pagination?.amount) ==
            pagination?.amount
          }
          onClick={() => {
            setPagination({
              ...pagination,
              offset:
                Math.round(pagination?.amount / +pagination?.limit?.value) *
                +pagination?.limit?.value,
            });
          }}
        >
          <NumberArrow>Last</NumberArrow>
        </Button>
      </div>
    </Row>
  );
}
